import moment from "moment";
import axios from "axios";
import { getSession } from "./session";
import { getter } from "./storage";

export const handleStartDate = (event, setStartDate) => {
  const selectedValue = event.target.value;
  let newStartDate;

  if (selectedValue === 1) {
    // Today
    newStartDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
  } else if (selectedValue === 2) {
    // 1 Week (starting from Monday)
    newStartDate = moment().startOf("isoWeek");
  } else if (selectedValue === 3) {
    // 2 Weeks (starting from the Monday of the previous week)
    newStartDate = moment().subtract(1, "weeks").startOf("isoWeek");
  } else if (selectedValue === 4) {
    // 1 Month (starting from the 1st day of the current month)
    newStartDate = moment().startOf("month");
  } else if (selectedValue === 5) {
    // All (no specific start date)
    // You can set a specific start date for "All" if needed
    newStartDate = moment().startOf("year");
  }
  setStartDate(newStartDate);
};

export const handleStartDateCommon = (
  val,
  setStartDate,
  setSelectedDuration,
  setEndDate
) => {
  const selectedValue = val.value;
  let newStartDate;
  let duration;
  if (selectedValue === 1) {
    // Today
    newStartDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    duration = 1;
  } else if (selectedValue === 2) {
    // 1 Week (starting from Monday)
    // newStartDate = moment().startOf("isoWeek");
    newStartDate = moment()
      .startOf("isoWeek")
      .subtract(7, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    duration = 2;
  } else if (selectedValue === 3) {
    // 2 Weeks (starting from the Monday of the previous week)
    // newStartDate = moment().subtract(1, "weeks").startOf("isoWeek");
    newStartDate = moment()
      .startOf("isoWeek")
      .subtract(14, "days")
      .format("YYYY-MM-DD HH:mm:ss");

    duration = 3;
  } else if (selectedValue === 4) {
    // 1 Month (starting from the 1st day of the current month)
    // newStartDate = moment().startOf("month");
    newStartDate = moment()
      .startOf("isoWeek")
      .subtract(30, "days")
      .format("YYYY-MM-DD HH:mm:ss");

    duration = 4;
  } else if (selectedValue === 5) {
    // All (no specific start date)
    // You can set a specific start date for "All" if needed
    // newStartDate = moment().startOf("year");
    duration = 5;
  }
  if (duration != 5) setStartDate(newStartDate);
  setEndDate(moment().locale("en").format("YYYY-MM-DD HH:mm:ss"));
  setSelectedDuration(duration);
};

export function getDeviceStatus(status) {
  if (status === "Online") {
    return "success";
  } else if (status === "Offline") {
    return "danger";
  } else if (status === "Idle") {
    return "warning";
  } else {
    return "";
  }
}

export const handleDownloadClick = (imageSrc) => {
  return new Promise((resolve, reject) => {
    axios({
      url: imageSrc,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "image.jpg"; // You can set the filename here
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        resolve("Image downloaded successfully");
      })
      .catch((error) => {
        console.error("Error downloading image:", error);
        reject(error);
      });
  });
};

export const formattedDateTime = (dateTimeString) => {
  return moment(dateTimeString).format("MMM DD, YYYY h:mm A");
};

export const formattedDateTimev2 = (dateTimeString) => {
  return moment.utc(dateTimeString).format("DD MMM YYYY | hh:mm:ss A");
};


export const deviceStatusClass = (status) => {
  switch (status) {
    case 0:
      return "text-danger";
    case 1:
      return "text-success";
  }
};

export const deviceStatusText = (status) => {
  switch (status) {
    case 0:
      return "Inactive Now";
    case 1:
      return "Active Now";
  }
};

export const formattedDateTimeForChatModule = (dateTimeString) => {
  const momentObj = moment(dateTimeString).locale("en");
  if (dateTimeString) {
    if (momentObj.isSame(moment(), "day")) {
      return momentObj.format("HH:mm"); // Display time in 'HH:mm' format for today
    } else {
      return momentObj.fromNow(); // Use fromNow for other dates
    }
  } else return "";
};

export function getCategoryStatusValue(item) {
  if (isBlockedByAdmin(item)) {
    return 4;
  } else if (item?.categoryStatus === 0) {
    return 1;
  } else if (item?.categoryStatus === 1) {
    return 2;
  } else if (item?.categoryStatus === 2) {
    return 3;
  } else {
    return 0;
  }
}

function isBlockedByAdmin(item) {
  if (item?.considerAdminChanges) {
    if (item?.blockedByAdmin === 1) {
      return true;
    }
  }
  return false;
}

export function getAccessToken(decryptedRequest) {
  const sessionStorageEncrypted = getSession("kidoProtectUser");
  const localStorageEncrypted = getter("kidoProtectUser");

  const sessionStorage = sessionStorageEncrypted ? decryptedRequest(sessionStorageEncrypted) : "";
  const localStorage = localStorageEncrypted ? decryptedRequest(localStorageEncrypted) : "";

  return sessionStorage ? JSON.parse(sessionStorage) : JSON.parse(localStorage);
}

export const extractQueryParam = (url, param) => {
  try {
    const urlObj = new URL(url);
    return urlObj.searchParams.get(param) || null;
  } catch (error) {
    // Fallback for malformed URLs or non-URL strings
    const queryString = url.split("?")[1];
    if (!queryString) return null;
    
    const params = new URLSearchParams(queryString);
    return params.get(param) || null;
  }
};